import api from '../api';
import { EventData } from '../../components/slices/WellNoteSlice';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';

interface WellNoteApiResponse {
  category: string;
  WellNoteId?: number | string;
  id?: number | string;
  wellId?: number;
  WellId?: number;
  categoryId?: number;
  WellNoteCategoryId?: number;
  description?: string;
  Comment?: string;
  note?: string;
  timestamp?: string;
  Created?: string;
  type?: string;
  Category?: string;
  Username?: string;
  date?: string;
  user?: string;
  userName?: string;
  addedBy?: string;
  userId?: string;
  eventId?: number | string;
}

export async function fetchWellNoteEvents(
  wellId: number | undefined,
  assetId: string | undefined,
  startDate?: string,
  endDate?: string,
  isESP?: boolean,
): Promise<EventData[]> {
  const params: Record<string, string | number | undefined> = { wellId };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const requestPayload = createWrapperPayload('POST', `/pumpchecker/Well/GetWellNotes?wellId=${wellId}`, { params });
  const response = !isESP
    ? await api.get(`/Comments/${assetId}`)
    : await api.post(wrapperConstants.router, requestPayload);

  // Transform API response to a uniform EventData shape with Title-case display fields
  const rawData = isESP ? (response.data.Data ?? []) : (response.data?.comments ?? []);
  const transformedData: EventData[] = rawData.map((item: WellNoteApiResponse) => {
    const id = item.WellNoteId || item.id || item.eventId || '';
    const mappedWellId = item.wellId || item.WellId || wellId || rawData.assetGuid;

    // Normalize commonly varying field names across APIs
    const category = item.Category || item.category || '';
    const comment = item.Comment || item.description || item.note || '';
    const created = item.Created || item.timestamp || item.date || new Date().toISOString();
    const username = item.Username || item.user || item.userName || item.addedBy || item.userId || '';

    return {
      ...item,
      id,
      wellId: mappedWellId,
      categoryId: item.categoryId || item.WellNoteCategoryId || 0,
      description: comment,
      timestamp: created,
      type: item.type || 'Note',
      Source: isESP ? 'PC' : 'OptiLift',
      // Title-case fields used by the table accessors
      Category: category,
      Comment: comment,
      Created: created,
      Username: username,
    } as EventData;
  });

  console.log('GetWellNotes transformed data:', transformedData);
  return transformedData;
}
